import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Tên đăng nhập", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Chọn quyền hạn", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-4 p-lg-3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Chọn đơn vị", -1)
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_18 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký tài khoản nhân viên" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            id: "fullname",
            type: "text",
            modelValue: $setup.register.fullname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.register.fullname) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            id: "username",
            type: "text",
            modelValue: $setup.register.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.username) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.register.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register.password) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputText, {
            id: "phoneNumber",
            type: "text",
            modelValue: $setup.register.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.register.phoneNumber) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Dropdown, {
            id: "permission",
            modelValue: $setup.register.permission,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.register.permission) = $event)),
            options: $setup.userPermission,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Vui lòng chọn quyền hạn của tài khoản ..."
          }, null, 8, ["modelValue", "options"])
        ]),
        ($setup.register.permission == 'user')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Dropdown, {
                id: "donVi",
                modelValue: $setup.register.idDonVi,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.register.idDonVi) = $event)),
                options: $setup.listDonVi,
                optionLabel: "tenDonVi",
                optionValue: "id",
                placeholder: "Vui lòng chọn đơn vị quản lý ..."
              }, null, 8, ["modelValue", "options"]),
              ($setup.register.idDonVi < 1)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, "Vui lòng chọn đơn vị"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        ($setup.register.permission == 'user')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportList, (report) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: report.key
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_Checkbox, {
                            modelValue: $setup.register.report,
                            "onUpdate:modelValue": ($event: any) => (($setup.register.report) = $event),
                            inputId: report.key,
                            name: "report",
                            value: report.key,
                            onClick: $setup.checkContent
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value", "onClick"]),
                          _createElementVNode("label", {
                            for: report.key
                          }, _toDisplayString(report.label), 9, _hoisted_18)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.doRegister()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}